import React from 'react';
import type { IconBaseProps, IconType } from 'react-icons';

// react-icons 5 typisiert Icons als (props) => ReactNode. React 19 akzeptiert
// diesen Rückgabetyp nicht direkt als JSX-Element (TS2786). Dieser Wrapper
// rendert das Icon typsicher, ohne strict-Checks abzuschwächen.
export const Icon: React.FC<{ icon: IconType } & IconBaseProps> = ({ icon, ...props }) => {
  const rendered = icon(props);
  return <>{rendered}</>;
};
